import { Input } from 'antd';
import { useTranslation } from '../../../i18n';
import { Box } from '../../../box';
import { Highlighter, DragItem } from '../../component';
import { service } from '../service';
import styles from '../style.module.less';
import { usePrimaryColor } from '../../hooks';
import type { ReactElement } from 'react';
import type { NumberProps } from './types';

export function NumberDesignMode(props: NumberProps): ReactElement {
  const [t] = useTranslation();
  const { rgbColor } = usePrimaryColor();

  // 拖拽时显示组件
  if (props.name == null) {
    return (
      <DragItem title={t('Number')} />
    );
  }

  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};
  return (
    <Box
      className={styles.designBox}
      style={{ ...activeStyle, paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={styles.input}>
        <Input
          type='text'
          value={props.value}
          placeholder={props.textPlaceholder ?? ''}
          readOnly={true}
        />
      </Box>
    </Box>
  );
}
